import React from 'react';
import { ExtensionThumbnail } from '../extension-thumbnail';
export const ExtensionListPageThumbnails = ({ extensions, user, institution, nativeExtensionsList, isInstalled, handleExtensionClick }) => {
    return <ul>
    {extensions.map((extension) => (<li key={extension.id}>
        <ExtensionThumbnail data-destid={`extension${extension.id}`} extension={extension} user={user} institution={institution} onClick={() => handleExtensionClick(extension)} isInstalled={isInstalled} isNative={Boolean(nativeExtensionsList.includes(extension.name))}/>
      </li>))}
  </ul>;
};
